import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  Paper,
  Box,
  IconButton,
} from '@mui/material';
import {
  PersonAdd as PersonAddIcon,
  ArrowBack as ArrowBackIcon,
  Save as SaveIcon,
  Badge as BadgeIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationOnIcon,
  Notes as NotesIcon,
  Search as SearchIcon,
  AccountCircle as AccountCircleIcon,
} from '@mui/icons-material';
import { useStateValue } from '../../../contexto/store';
import {
  insertarContacto,
  obtenerClientes,
} from '../../../actions/ClientesAction';
import ModalClientes from '../../GestionDeClientes/ModalClientes.js';
import { RegistrarAccion } from '../../../actions/AuditoriaAction';

const NuevoContacto = (props) => {
  const [clientes, setClientes] = useState('');
  const mounted = useRef(true);
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [Datacl, setDatacl] = useState([]);
  const seleccionarCliente = (cliente) => {
    setClientes(cliente.nombre + ' ' + cliente.apellido);
    setClienteId(cliente.clientE_Id);
    setModalBuscar(false);
  };
  const [contacto, setContacto] = useState({
    NOMBRE: '',
    APELLIDO: '',
    TELEFONO: '',
    DIRECCION: '',
    EMAIL: '',
    USUARIO: '',
    OBSERVACIONES: '',
  });
  const [modalBuscar, setModalBuscar] = useState(false);
  const [clienteId, setClienteId] = useState('');
  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setContacto((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
  const abrirModal = () => {
    setModalBuscar(true);
  };
  const cerrarModal = () => {
    setModalBuscar(false);
  };
  const registrarContacto = () => {
    if (contacto.APELLIDO !== '' || contacto.CI !== '') {
      const usuario = sesionUsuario.usuario.nombrecompleto;
      let objetoNuevo = {};
      if (clienteId === '' || clienteId === undefined) {
        objetoNuevo = {
          NOMBRE: contacto.NOMBRE,
          APELLIDO: contacto.APELLIDO,
          TELEFONO: contacto.TELEFONO,
          DIRECCION: contacto.DIRECCION,
          EMAIL: contacto.EMAIL,
          OBSERVACIONES: contacto.OBSERVACIONES,
          USUARIO: usuario,
          UsuarioId: sesionUsuario.usuario.id,
        };
      } else {
        objetoNuevo = {
          NOMBRE: contacto.NOMBRE,
          APELLIDO: contacto.APELLIDO,
          TELEFONO: contacto.TELEFONO,
          DIRECCION: contacto.DIRECCION,
          EMAIL: contacto.EMAIL,
          OBSERVACIONES: contacto.OBSERVACIONES,
          USUARIO: usuario,
          CLIENTE_Id: clienteId,
          UsuarioId: sesionUsuario.usuario.id,
        };
      }
      insertarContacto(objetoNuevo).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Se guardo con exito el contacto ',
            },
          });
          setContacto({
            NOMBRE: '',
            APELLIDO: '',
            TELEFONO: '',
            DIRECCION: '',
            EMAIL: '',
            USUARIO: '',
            OBSERVACIONES: '',
          });
          setClienteId('');
          let objetoAudi = {
            usuario: sesionUsuario.usuario.nombrecompleto,
            accion: 'Registro',
            panel: 'Gestion de Clientes',
            tabla: 'CONTACTOS',
            filaafectada: 'NUEVO REGISTRO',
            UsuarioId: sesionUsuario.usuario.id,
          };
          RegistrarAccion(objetoAudi);
          volver();
        } else {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Errores al intentar guardar ',
            },
          });
        }
      });
    } else {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje:
            'Los Campos Apellido y Ci son obligatorios Asegurese de llenarlos',
        },
      });
    }
  };
  const volver = () => {
    props.history.goBack();
  };

  useEffect(() => {
    if (mounted.current) {
      obtenerClientes().then((response) => {
        const Data = response.data;
        setDatacl(Data);
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 4,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            <PersonAddIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Nuevo Contacto
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
              Registra un nuevo contacto en el sistema
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Información Principal */}
      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
          Información del Contacto
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              name="NOMBRE"
              value={contacto.NOMBRE}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Nombre"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <BadgeIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="APELLIDO"
              value={contacto.APELLIDO}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Apellido/Razón Social *"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <BadgeIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="TELEFONO"
              value={contacto.TELEFONO}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Teléfono"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <PhoneIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="DIRECCION"
              value={contacto.DIRECCION}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Dirección"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <LocationOnIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="EMAIL"
              value={contacto.EMAIL}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Email"
              type="email"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <EmailIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="OBSERVACIONES"
              value={contacto.OBSERVACIONES}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              label="Observaciones"
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'flex-start', pt: 1.5 }}>
                    <NotesIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>

          {/* Cliente relacionado */}
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                mb: 2,
              }}
            >
              <IconButton
                onClick={abrirModal}
                color="primary"
                sx={{
                  backgroundColor: 'action.hover',
                  '&:hover': {
                    backgroundColor: 'action.selected',
                  },
                }}
              >
                <SearchIcon />
              </IconButton>
              <Typography variant="body2" color="text.secondary">
                Relacionar este contacto con un cliente existente (opcional)
              </Typography>
            </Box>
            <TextField
              name="CLIENTE"
              value={clientes}
              fullWidth
              variant="outlined"
              label="Cliente Relacionado"
              disabled
              InputProps={{
                startAdornment: (
                  <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                    <AccountCircleIcon sx={{ color: 'action.active', fontSize: 20 }} />
                  </Box>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Botones de acción */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
        }}
      >
        <Button
          variant="outlined"
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={volver}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            borderWidth: 2,
            '&:hover': {
              borderWidth: 2,
              transform: 'translateY(-2px)',
              boxShadow: 2,
            },
            transition: 'all 0.2s ease',
          }}
        >
          Volver
        </Button>

        <Button
          variant="contained"
          size="large"
          startIcon={<SaveIcon />}
          onClick={registrarContacto}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            boxShadow: 2,
            '&:hover': {
              boxShadow: 4,
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.2s ease',
          }}
        >
          Registrar Contacto
        </Button>
      </Box>

      {/* Modal de búsqueda de clientes */}
      <ModalClientes
        data={Datacl}
        open={modalBuscar}
        handleClose={cerrarModal}
        seleccionarCliente={seleccionarCliente}
        datosCargados={Datacl.length > 0}
      />
    </Container>
  );
};
export default NuevoContacto;
